import { DISCOUNT_NOTES, MINIMUM_DISCOUNT_RATE } from '~/lib/constants/constants'
import { css } from '~/styled-system/css'

type Props = {
  discountRate: number
  timeSaleEndDate?: string
}

export function DiscountNotes({ discountRate, timeSaleEndDate }: Props) {
  if (discountRate < MINIMUM_DISCOUNT_RATE) {
    return null
  }
  return (
    <p>
      {timeSaleEndDate && (
        <>
          ※タイムセールの期間や割引率は予告なく変更となる場合があります。
          <br />
        </>
      )}
      {DISCOUNT_NOTES}
    </p>
  )
}

export function TimesaleSpanNote({ discountRate, timeSaleEndDate }: Props) {
  if (discountRate < MINIMUM_DISCOUNT_RATE) {
    return null
  }
  if (!timeSaleEndDate) {
    return null
  }
  return (
    <p className={css({ fontSize: 'xs', _pc: { fontSize: 'sm' } })}>
      タイムセール期間：{timeSaleEndDate}まで
    </p>
  )
}
